import { getEvento, update } from "../index";
import { Interesados as Subs } from '../../../Suscripciones';
import { getParticipantes } from "../../../Context/Participante";
export default function Interesados() {
    const p = getEvento();
    const l = getParticipantes();
    const i = p.interesados.filter(e => l.some(p => p.id === e.id));
    return <Subs i={i} url={`evento/${p.id}`} u={update} />
}